module.exports = __webpack_public_path__ + "img/search.cb318e05.svg";